<template>
  <div class="mit-admin-page mit-page">
    <v-container fluid class="pa-0 ma-0">
        <div v-if="spaces && filteredSpaces.length > 0">
          <v-simple-table fixed-header height="300px">
            <template v-slot:default>
              <thead>
                <tr>
                    <!-- <th class="pa-0 ma-0 text-left"></th> -->
                    <!-- <th class="text-left">Space</th> -->
                    <!-- <th class="text-left">Available For</th> -->
                    <!-- <th class="text-left"></th> -->
                    <!-- <th class="text-left">Building</th> -->
                    <th class="text-left">Space</th>
                    <th class="text-left">Floor</th>
                    <th class="text-left">Capacity</th>
                    <th class="text-left"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="space in filteredSpaces" :key="space.mitId">
                  <!-- <td class="pa-0 ma-0">
                    <v-btn class="pa-0 ma-0" small @click="spaceFavoriteClick(space)" icon>
                          <v-icon class="pa-0 ma-0" v-if="space.favorite === true" color="red lighten-1">mdi-heart</v-icon>
                          <v-icon class="pa-0 ma-0" v-else>mdi-heart-outline</v-icon>
                      </v-btn>
                  </td> -->
                  
                  <!-- <td class="pa-0 ma-0" >
                      <a target="_blank" rel="noopener noreferrer" :href="linkToMapUrl+'/maps/'+space.buildingMitId+'?s='+space.mitId+'&l='+space.level">
                        <v-icon class="pa-0 ma-0">mdi-map-marker</v-icon>
                      </a>
                  </td> -->
                  <td>
                      <!-- <a target="_blank" rel="noopener noreferrer" :href="linkToMapUrl+'/maps/'+space.buildingMitId+'?s='+space.mitId+'&l='+space.level"> -->
                        <!-- <a @click="reserveSpace(space)">
                          <h4>
                              {{space.nameFormatted}}
                          </h4>
                      </a> -->
                      <a target="_blank" rel="noopener noreferrer" :href="linkToMapUrl+'/maps/'+space.buildingMitId+'?s='+space.mitId+'&l='+space.level">
                                                        <h4>
                                                            <!-- {{space.name || space.mitId}} -->
                                                            {{space.nameFormatted}}
                                                        </h4>
                                                    </a>
                  </td>
                  <!-- <td>{{ space.dates_local.nextStartTimeLeft }}</td> -->
                  <!-- <td><v-btn class="" small text outlined color="primary" elevation="0" @click="reserveSpace(space)">Reserve</v-btn></td> -->
                  <!-- <td>{{ space.buildingMitId }}</td> -->
                  <td>{{ space.level }}</td>
                  <td>{{ space.maxCapacity }}</td>
                  <td><v-btn class="" small text outlined color="primary" elevation="0" @click="reserveSpace(space)">Reserve</v-btn></td>
                  
                </tr>
              </tbody>
            </template>
          </v-simple-table>
        </div>
        <div v-else style="height:300px">
            <center>
                <h3 style="padding-top: 70px;">No favorites set</h3>
                <div>Set favorites in the <router-link to="reserve">New Reservation</router-link> page by clicking the heart icon <v-icon>mdi-heart-outline</v-icon></v-idon>.</div>
            </center>
        </div>
        
    </v-container>
  </div>
</template>

<script>  

  export default {
    name: 'MitMyFavoriteSpaces',
    components: {
    },
    props: {
      linkToMapUrl:{
          default () {
              return '';
          },
          type: String
      },
      spaces:{
          default () {
              return [];
          },
          type: Array
      }
    },
    data: function() {
      return {
      }
    },
    created() {
    },
    computed: {
      filteredSpaces() {
              return this.spaces.filter(
                  (x) => { return x.favorite }
              );
      }
  },
    mounted() {

    },
    methods: {
        reserveSpace(space){
          this.$emit('newReservation', space);
        },
        spaceFavoriteClick(space){
          this.$emit('favoriteChanged', space);
        }
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep .row-pointer {
    tbody {
      tr {
        cursor: pointer;
      }
    }
  }

</style>
